import React, { useState } from "react";
import {
    Card,
    CardBody,
    Col,
    Dropdown,
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
} from "reactstrap";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import BootstrapTheme from "@fullcalendar/bootstrap";

const StudentCalender = () => {
    const [dropdownOpen, setDropdownOpen] = useState(false);

    const toggle = () => setDropdownOpen((prevState) => !prevState);



    return (
        <React.Fragment>
            <Col lg={6}>
                <Card>
                    <CardBody>
                        <Dropdown
                            isOpen={dropdownOpen}
                            toggle={toggle}
                            className="float-end"
                        >
                            <DropdownToggle tag="i" className="arrow-none card-drop">
                                <i className="mdi mdi-dots-vertical"></i>
                            </DropdownToggle>
                            <DropdownMenu className="dropdown-menu-end">
                                <DropdownItem>Sales Report</DropdownItem>

                                <DropdownItem>Export Report</DropdownItem>

                                <DropdownItem>Profit</DropdownItem>

                                <DropdownItem>Action</DropdownItem>
                            </DropdownMenu>
                        </Dropdown>

                        <h4 className="card-title mb-4">Schedules</h4>
                        <FullCalendar

                            plugins={[
                                BootstrapTheme,
                                dayGridPlugin,
                                interactionPlugin,
                            ]}
                            headerToolbar={{
                                left: "prev,next today",
                                center: "title",
                                right: "dayGridMonth,dayGridWeek,dayGridDay",
                            }}
                            slotDuration={"00:15:00"}
                            handleWindowResize={true}
                            themeSystem="bootstrap"
                            events={null}
                            editable={true}
                            droppable={true}
                            selectable={true}
                        />
                    </CardBody>
                </Card>
            </Col>
        </React.Fragment>
    );
};

export default StudentCalender;
